import { useEffect } from 'react'

const SprigScript = ({ nonce }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (window?.latmconf && window?.latmconf?.trackSprigEvent) {
        window.latmconf.trackSprigEvent('devdashnodeweb-intercept-jan2024-web')
      }
    }, 3000)

    return () => clearTimeout(timer)
  }, [nonce])
  return null
}

export default SprigScript
